import { Component, OnInit } from '@angular/core';
import { BaseFormComponent } from 'src/app/shared/base/base-form.component';
import { OptionsSource } from 'src/app/core/core.models';
import { AuthService } from 'src/app/core/auth.service';
import { LoadingService } from 'src/app/core/loading.service';
import { TranslatorService } from 'src/app/core/translator.service';
import { UtilityService } from 'src/app/core/utility.service';
import { DialogService, Dialog } from 'src/app/core/dialog.service';
import { AlertService } from 'src/app/core/alert.service';

import { ActivatedRoute, Router } from '@angular/router';
import { BaseService } from 'src/app/shared/base/base.service';
import { Constants } from 'src/app/app.constants';
import { DistributionChannel, DistributionChannelStatus, DistributionChannelDailyCapacity } from '../distribution-channels.models';
import { PointsOfSaleService } from '../../points-of-sale/points-of-sale.service';
import { MeansOfDeliveryService } from '../../means-of-delivery/means-of-delivery.service';
import { DeliveryZonesService } from '../../delivery-zones/delivery-zones.services';
import { PointOfSale } from '../../points-of-sale/points-of-sale.models';
import { MeanOfDelivery } from '../../means-of-delivery/means-of-delivery.models';
import { DayOfWeek, ValueLabel } from 'src/app/shared/base/base.models';
import { TranslateService } from '@ngx-translate/core';
import { DistributionChannelsService } from '../distribution-channels.service';
import { Time } from '@angular/common';
import { DeliveryZone } from '../../delivery-zones/delivery-zones.models';

@Component({
  selector: 'app-distribution-channels-form',
  templateUrl: './distribution-channels-form.component.html',
  styleUrls: ['./distribution-channels-form.component.scss']
})
export class DistributionChannelsFormComponent extends BaseFormComponent implements OnInit {
  public daysOfWeek: ValueLabel[] = [];
  public selectedDays: string[] = [];
  public timeFrom: Time;
  public timeTo: Time;
  public capacityPerHour: number;
  public distributionChannelsStatuses: ValueLabel[] = [];
  public pointsOfSale: OptionsSource;
  public meansOfDelivery: OptionsSource;
  public deliveryZone: OptionsSource;

  public dailyCapacities: DistributionChannelDailyCapacity[] = [];
  public showActivateButton: boolean = true;
  public showDeactivateButton: boolean = false;

  public tabs = ['DAILY_CAPACITIES'];

  public isChooseDaysModalVisible: boolean = false;
  public minDateFrom: Date = new Date();

  constructor(
    private distributionChannelsService: DistributionChannelsService,
    private translateService: TranslateService,
    private deliveryZonesService: DeliveryZonesService,
    private pointsOfSaleService: PointsOfSaleService,
    private meansOfDeliveryService: MeansOfDeliveryService,
    public authService: AuthService,
    public loadingService: LoadingService,
    public translatorService: TranslatorService,
    public utilityService: UtilityService,
    protected activatedRoute: ActivatedRoute,
    protected baseService: BaseService,
    protected dialogService: DialogService,
    protected router: Router,
    protected alertService: AlertService
  ) {
    super(authService, loadingService, translatorService, utilityService, activatedRoute, baseService, dialogService, router, alertService)
  }

  ngOnInit(): void {
    this.authorities.init('CD_CD', 'R_CD', 'U_CD', 'CD_CD');
    this.url = `${Constants.contextPath}/distribution-channels`;
    this.prepareLookupData();
    this.prepareFormData(new DistributionChannel(), (response: DistributionChannel) => {
      return this.modifyResponse(response);
    });
  }

  modifyResponse(response) {
    response.breadcrumbsId = response.documentNumber;

    if (response.pointOfSale) {
      let pointOfSale = <PointOfSale>response.pointOfSale;
      response.pointOfSale = pointOfSale.id;
    }

    if (response.meansOfDelivery) {
      let meansOfDelivery = <MeanOfDelivery>response.meansOfDelivery;
      response.meansOfDelivery = meansOfDelivery.id;
    }

    if (response.deliveryZone) {
      let deliveryZone = <DeliveryZone>response.deliveryZone;
      response.deliveryZone = deliveryZone.id;
    }

    if (response.dailyCapacities) {
      this.dailyCapacities = response.dailyCapacities;
    }

    this.showActivateButton = response.status == DistributionChannelStatus[DistributionChannelStatus.PREPARATION];
    this.showDeactivateButton = response.status == DistributionChannelStatus[DistributionChannelStatus.ACTIVE];

    return response;
  }

  prepareLookupData() {
    this.distributionChannelsStatuses = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(DistributionChannelStatus, true), 'value', 'label', 'ENUMS.DESTRIBUTION_CHANNEL_STATUS.');
    this.daysOfWeek = this.utilityService.prepareLookupItems(this.utilityService.enumToSelectArray(DayOfWeek, true), 'value', 'label', 'ENUMS.DAYS_OF_WEEK.');
    this.pointsOfSale = this.pointsOfSaleService.getPointsOfSaleOptions();
    this.meansOfDelivery = this.meansOfDeliveryService.getMeansOfDeliveryOptions();
    this.deliveryZone = this.deliveryZonesService.getDeliveryZonesOptions();
  }

  onToolbarPreparing(event) {
    let self = this;
    if (this.authorities.update && this.showActivateButton) {
      event.toolbarOptions.items.unshift({
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'trash',
          hint: this.translateService.instant('SHARED.DELETE_ALL'),
          onClick: this.deleteAllItems.bind(this)
        },
        locateInMenu: 'auto'
      });
    }

    if(this.authorities.update && this.showActivateButton) {
      event.toolbarOptions.items.unshift({
        widget: 'dxButton',
        options: {
          icon: 'plus',
          hint: this.translateService.instant('DISTRIBUTION_CHANNELS.CHOOSE_DAYS'),
          text: this.translateService.instant('DISTRIBUTION_CHANNELS.CHOOSE_DAYS'),
          showText: 'always',
          onClick: function () {
            self.openChooseDaysModal();
          },
          disabled: !this.showActivateButton,
          stylingMode: 'outlined'
        },
        location: 'after',
        locateInMenu: 'auto'
      });
    }
  }

  public openChooseDaysModal() {
    this.isChooseDaysModalVisible = true;
  }


  public deleteAllItems() {
    let dialog = new Dialog('PRODUCT_CATALOGUES.DELETE_ALL_ITEMS', () => {
      this.dailyCapacities = [];
      this.alertService.success('PRODUCT_CATALOGUES.DELETE_ALL_ITEMS_SUCCESS');
    });

    this.dialogService.show(dialog);
  }

  public changeStatus() {
    let activate: boolean = true;
    let changeToStatus: string = this.formData.status == DistributionChannelStatus[DistributionChannelStatus.ACTIVE] ? DistributionChannelStatus[DistributionChannelStatus.INACTIVE] : DistributionChannelStatus[DistributionChannelStatus.ACTIVE]
    if (this.formData.status == DistributionChannelStatus[DistributionChannelStatus.ACTIVE])
      activate = false;

    let dialogData = new Dialog(activate ? 'SHARED.ACTIVATE_QUESTION' : 'SHARED.DEACTIVATE_QUESTION', () => {

      this.baseService.patch(`${this.url}/${this.id}/change-status/${changeToStatus}`, null, (response) => {
        this.formData = this.modifyResponse(response);
        this.initialFormData = {...this.formData};
        this.pendingChanges = false;
        this.alertService.success(activate ? 'SHARED.ACTIVATE_SUCCESS' : 'SHARED.DEACTIVATE_SUCCESS');
        this.router.navigate(['distribution-channels']);
      }, (error) => {
        this.alertService.error(error);
      });
    });

    this.dialogService.show(dialogData);
  }

  public saveChanges(): void {

    if (!this.isFormValid())
      return;

    this.formData.dailyCapacities = this.dailyCapacities;

    if (this.id == null) {
      this.formData.status = DistributionChannelStatus[DistributionChannelStatus.PREPARATION];

      this.baseService.create(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
    } else
      this.baseService.update(this.url, this.formData, () => {
        this.onSaveSuccess();
      });
  }

  public addDays()
  {
    this.pendingChanges = true;
    this.selectedDays.forEach(p => {
      let d: DistributionChannelDailyCapacity = new DistributionChannelDailyCapacity();
      d.dayOfWeek = p;
      d.capacityPerHour = this.capacityPerHour;
      d.timeFrom = this.timeFrom;
      d.timeTo = this.timeTo;
      
      this.dailyCapacities.push(d);
    });

    this.closeAddDaysModal();
  }

  closeAddDaysModal(){
    this.isChooseDaysModalVisible = false;
  }
}
